module.exports = __webpack_public_path__ + "img/auth-banner.40622f51.png";